import { Button, ButtonGroup, Flex, ScrollView } from "@aws-amplify/ui-react"
import type { UserDataDto } from "@strtmn/sds/types"
import { getErrorMessage } from "@strtmn/strtmn"
import { I18n } from "aws-amplify/utils"
import { useEffect, useState } from "react"
import { Link } from "react-router-dom"
import { listUsers } from "../../api/userData"
import { LoadingErrorState, RoundedCard } from "../../components"
import UserTable from "../../components/admin/UserTable"
import SearchField from "../../components/maschinen-liste/SearchField"

export function AdminUsers() {
  const [users, setUsers] = useState<UserDataDto[] | null>(null)
  const [loading, setLoading] = useState<boolean>(true)
  const [error, setError] = useState<string | undefined>(undefined)

  useEffect(() => {
    const loadUsers = async () => {
      setLoading(true)
      setUsers(null)
      setError(undefined)
      try {
        const _users = await listUsers()
        setUsers(_users || null)
      } catch (err) {
        console.log(
          "AU.loadUsers: Caught an error:",
          JSON.stringify(err, null, 2)
        )
        setError(getErrorMessage(err))
      } finally {
        setLoading(false)
      }
    }
    loadUsers()
  }, [])

  if (loading || error) {
    /** @todo add white text color */
    return (
      <LoadingErrorState
        isLoading={loading}
        loadingMessage={I18n.get("Lade Benutzerdaten, bitte warten...")}
        isError={!!error}
        errorMessage={`${I18n.get("Fehler")}: ${I18n.get(error!)}`}
      />
    )
  }

  const loadedUsers = users!
  // const pushU1ToBack = 1
  // const pushU2ToBack = -1
  // loadedUsers.sort((u1, u2) => {
  //   if (u1.created_at !== u2.created_at) {
  //     return u1.created_at < u2.created_at ? pushU1ToBack : pushU2ToBack
  //   }
  //   // Sort by last_name
  //   if (!u1.last_name && !u2.last_name) {
  //     return 0
  //   }
  //   if (!u1.last_name && u2.last_name) {
  //     return pushU1ToBack
  //   }
  //   if (u1.last_name && !u2.last_name) {
  //     return pushU2ToBack
  //   }
  //   if (u1.last_name! < u2.last_name!) {
  //     return pushU2ToBack
  //   }
  //   if (u1.last_name! > u2.last_name!) {
  //     return pushU1ToBack
  //   }

  //   return 0
  // })

  return (
    <main className="p-8 pt-2">
      <Flex
        className="!mb-4"
        justifyContent="space-between"
        alignItems="center"
        alignContent="center"
      >
        <div className="page-heading">{I18n.get("Benutzer verwalten")}</div>
        <SearchField whiteBackground={true} />
      </Flex>

      <RoundedCard>
        <ScrollView
          width="100%"
          height="calc(100vh - 300px)" // or any desired height
          minHeight="200px"
        >
          <UserTable users={loadedUsers} newUsers={false} />
        </ScrollView>

        <ButtonGroup size="small">
          <Link to="../new-users">
            <Button>{I18n.get("Neue Benutzer")}</Button>
          </Link>

          <Link to="..">
            <Button variation="link" size="small">
              {I18n.get("Zurück")}
            </Button>
          </Link>
        </ButtonGroup>
      </RoundedCard>
    </main>
  )
}
